import LogApiCallService from "@/services/feature/logApiCall.service";
// import moment from 'moment';

export const logApiCallApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, params) {
      return LogApiCallService.get(params).then(
        (resp) => {
          commit("dummy", "LogApiCallService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "LogApiCallService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
    getOne({ commit }, logGuid) {
      return LogApiCallService.getOne(logGuid).then(
        (resp) => {
          commit("dummy", "LogApiCallService.getOne - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "LogApiCallService.getOne - error");
          return Promise.reject(error.response);
        }
      );
    },

    getFilterItems({ commit }) {
      return LogApiCallService.getFilterItems().then(
        (resp) => {
          commit("dummy", "LogApiCallService.getFilterItems - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "LogApiCallService.getFilterItems - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
